import DragHandle from '@material-ui/icons/DragHandle';
import Close from '@material-ui/icons/Close';

export const CloseIcon = Close;
export const DragHandleIcon = DragHandle;
